var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_266_8463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.22822 16.5532C7.59662 16.5532 7.96502 16.4223 8.26214 16.1606C10.0327 14.6011 13.4564 11.1378 13.4564 7.67451C13.4564 4.23474 10.668 1.44629 7.22822 1.44629C3.78845 1.44629 1 4.23474 1 7.67451C1 11.1378 4.42373 14.6011 6.1943 16.1607C6.49142 16.4224 6.85982 16.5532 7.22822 16.5532Z",
    stroke: "#A1A1AA",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2284 10.01C8.51831 10.01 9.56399 8.96436 9.56399 7.67445C9.56399 6.38454 8.51831 5.33887 7.2284 5.33887C5.9385 5.33887 4.89282 6.38454 4.89282 7.67445C4.89282 8.96436 5.9385 10.01 7.2284 10.01Z",
    stroke: "#A1A1AA",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_266_8463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4564,
    height: 17.1069,
    fill: "white",
    transform: "translate(0 0.446289)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.80657bcbd052308adee49cce0a27eae7.svg";
export { ForwardRef as ReactComponent };